// const { version } = require('element-ui/package.json');
// let ORIGINAL_THEME = '#409EFF' // default color

export default {
  name: 'AcolorPicker',
  props: {
    value: null,
    size: { type: String, default: () => 'small' },
    default: { type: String, default: () => '#c58577' },
    predefine: {
      type: Array,
      default: () => [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#67c23a',
        '#13ce66',
        '#00ced1',
        '#409eff',
        '#1e90ff',
        '#c71585',
        '#c58577',
        '#d81e06',
        '#f4ea2a',
        '#1afa29',
        '#1296db',
        '#13227a',
        '#d4237a',
        '#ffffff',
        '#e6e6e6',
        '#dbdbdb',
        '#cdcdcd',
        '#bfbfbf',
        '#8a8a8a',
        '#707070',
        '#515151',
        '#2c2c2c',
      ]
    },
  },
  data() {
    return {
      theme: '',
      // chalk: '',
    }
  },
  // computed: {
  //   defaultTheme() {
  //     return this.$store.state.theme;
  //   }
  // },
  watch: {
    // defaultTheme: {
    //   immediate: true,
    //   handler(theme) {
    //     this.theme = theme;
    //   },
    // },
    // async theme(val) {
    //   const oldVal = this.chalk ? this.theme : this.default;
    //   if (typeof val !== 'string') return;
    //   const themeCluster = this.getThemeCluster(val.replace('#', ''));
    //   const originalCluster = this.getThemeCluster(oldVal.replace('#', ''));
    //   const $message = this.$message({
    //     message: '  Compiling the theme',
    //     customClass: 'theme-message',
    //     type: 'success',
    //     duration: 0,
    //     iconClass: 'el-icon-loading',
    //   });
    //   const getHandler = (variable, id) => {
    //     return () => {
    //       const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''));
    //       const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster);
    //       let styleTag = document.getElementById(id);
    //       if (!styleTag) {
    //         styleTag = document.createElement('style');
    //         styleTag.setAttribute('id', id);
    //         document.head.appendChild(styleTag);
    //       }
    //       styleTag.innerText = newStyle;
    //     }
    //   }
    //   if (!this.chalk) {
    //     const url = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`;
    //     await this.getCSSString(url, 'chalk');
    //   }
    //   const chalkHandler = getHandler('chalk', 'chalk-style');
    //   chalkHandler();
    //   const styles = [].slice.call(document.querySelectorAll('style')).filter(style => {
    //     const text = style.innerText;
    //     return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text);
    //   });
    //   styles.forEach(style => {
    //     const { innerText } = style;
    //     if (typeof innerText !== 'string') return;
    //     style.innerText = this.updateStyle(innerText, originalCluster, themeCluster);
    //   });
    //   this.$emit('change', val);
    //   $message.close();
    // }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.theme = this.value;
    },
    input(a) {
      this.$emit('input', a ? a : '');
    },
    change(a) {
      this.$emit('input', a ? a : '');
      this.$emit('change', a ? a : '');
      this.$emit('choose', a ? a : '');
    },
    select(a) {
      this.$emit('input', a ? a : '');
      this.$emit('select', a ? a : '');
      this.$emit('choose', a ? a : '');
    },
    // updateStyle(style, oldCluster, newCluster) {
    //   let newStyle = style;
    //   oldCluster.forEach((color, index) => {
    //     newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index]);
    //   })
    //   return newStyle;
    // },
    // getCSSString(url, variable) {
    //   return new Promise(resolve => {
    //     const xhr = new XMLHttpRequest();
    //     xhr.onreadystatechange = () => {
    //       if (xhr.readyState === 4 && xhr.status === 200) {
    //         this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '')
    //         resolve()
    //       }
    //     }
    //     xhr.open('GET', url);
    //     xhr.send();
    //   });
    // },
    // getThemeCluster(theme) {
    //   const tintColor = (color, tint) => {
    //     let red = parseInt(color.slice(0, 2), 16);
    //     let green = parseInt(color.slice(2, 4), 16);
    //     let blue = parseInt(color.slice(4, 6), 16);
    //     if (tint === 0) { // when primary color is in its rgb space
    //       return [red, green, blue].join(',');
    //     } else {
    //       red += Math.round(tint * (255 - red));
    //       green += Math.round(tint * (255 - green));
    //       blue += Math.round(tint * (255 - blue));
    //       red = red.toString(16);
    //       green = green.toString(16);
    //       blue = blue.toString(16);
    //       return `#${red}${green}${blue}`;
    //     }
    //   }
    //   const shadeColor = (color, shade) => {
    //     let red = parseInt(color.slice(0, 2), 16);
    //     let green = parseInt(color.slice(2, 4), 16);
    //     let blue = parseInt(color.slice(4, 6), 16);
    //     red = Math.round((1 - shade) * red);
    //     green = Math.round((1 - shade) * green);
    //     blue = Math.round((1 - shade) * blue);
    //     red = red.toString(16);
    //     green = green.toString(16);
    //     blue = blue.toString(16);
    //     return `#${red}${green}${blue}`;
    //   }
    //   const clusters = [theme];
    //   for (let i = 0; i <= 9; i++) {
    //     clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
    //   }
    //   clusters.push(shadeColor(theme, 0.1));
    //   return clusters;
    // }
  },
  render() {
    const { showAlpha = false, ...attrs } = this.$attrs;
    return (
      <el-color-picker
        size={this.size}
        v-model={this.theme}
        on-input={this.input}
        show-alpha={showAlpha}
        on-change={this.select}
        on-active-change={this.change}
        predefine={this.predefine}
        {...{ attrs }}
      />
    );
  }
}